<template>
<transition name="zoom">
  <div class="record">
    <Header :color="'white'" :fontColor="'black'">
      <div slot="center" class="header_bar">
        <div @click="changePage(1)" :class="{type_active: page===1}">余额明细</div>
        <div @click="changePage(2)" :class="{type_active: page===2}">提现记录</div>
      </div>
    </Header>
    <!-- 账单详情 -->
    <div v-if="page===1">
      <div class="bar">
        可用余额(元)
        <div class="bar_item">{{xx}}</div>
      </div>
      <div class="detail">
        <div v-for="item in billData" :key="item.mounth" class="d_item">
          <div class="month">{{item.month}}</div>
          <div v-for="item2 in item.userBalanceLogVos" :key="item2.id" class="card"> 
            <div class="top">
              <div class="top_left" v-if="item2.type===1"><img src="@/assets/个人中心/money.png" alt="">{{item2.orderSource | parseSource}}佣金</div>
              <div class="top_left" v-else>
                <img src="@/assets/个人中心/getmoney.png" alt="">
   
  
                
                提现
              </div>
              <div>{{item2.createTime | parseTime2}}</div>
            </div>
            <div class="content">
              <div>{{item2.type===1?'已存余额':'提现'}}</div>
              <!-- 审核中，48小时内处理，请耐心等待~ -->
              <div class="amount"><span v-if="item2.type===1">+</span>{{item2.amount}}</div>
            </div>
          </div>
        </div>
      <div v-if="billData.length === 0" class="tips">
        <img src="@/assets/个人中心/income.png" alt="">
        暂无余额明细
      </div> 
      </div>
    </div>
    <!-- 提现记录 -->
    <div v-else>
      <div class="detail">
          <!-- <div class="month">{{item.month}}</div> -->
        <div v-for="(item,index) in withdrawData" :key="index" class="card"> 
          <div class="top">
            <div class="top_left">
              <img src="@/assets/个人中心/getmoney.png" alt="">
              {{item.createTime | parseTime2(true)}}{{item.orderSource | parseSource}}
              提现
            </div>
            <div>{{item.createTime | parseTime2}}</div>
          </div>
          <div class="content">
            <div>{{item.status|status}}<span v-if="item.status ==4">: {{item.reasons}}</span></div>
            <div class="amount">{{item.cashAmount}}</div>
          </div>
        </div>
      <div v-if="withdrawData.length === 0" class="tips">
        <img src="@/assets/个人中心/withdraw.png" alt="">
        暂无提现记录
      </div> 
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import Header from "@/components/Header/index";
import { getUserBalanceLog,getUserCashList } from "@/api/userBalance";
export default {
  name:'Record',
  components:{
    Header
  },
  filters:{
    status(val){
      if(val == 1){
        return '审核中，48小时内处理，请耐心等待~'
      }else if(val == 2){
        return '提现成功'
      }else if(val == 3){
        return '提现成功'
      }else if(val == 4){
        return '提现失败'
      }
    }
  },
  data(){
    return{
      page: this.$route.query.page * 1,
      billData:[
      ],
      withdrawData:[
      ],
    }
  },
  computed:{
    xx(){
      return this.$store.state.userData.balance
    }
  },
  created () {
    getUserBalanceLog({    
      lastId:"",
      userId:this.$store.state.userId
    }).then(res=>{
      this.billData = res.data
    })
    var form = new FormData();
    form.append("userId",this.$store.state.userId); 
    getUserCashList(form).then(res=>{
      this.withdrawData = res.data
    })
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      vm.page = vm.$route.query.page * 1
    })
  },


  methods:{
    changePage(page){
      this.page = page
    }
  }
}
</script>

<style lang="less" scoped>
  .header_bar{
    display: flex;
    font-size: 1.5rem;
    align-items: center;
    :nth-child(1){
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;  
      border-right: 0;    
    }
    :nth-child(2){
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;      
    }

    div{
      padding: 5px;
      text-align: center;
      width: 40rem;
      white-space: nowrap;
      border: 1px solid transparent;
      border-radius: 4px;
      color: rgb(150, 150, 150);
      background-color: rgba(240, 240, 240,.7);
    }
    .type_active{
      background-color: #F63A25;
      color: white;
    }
  }
  .bar{
    width: 94vw;
    height: 8rem;
    background-color: #fff;
    margin: 3vw ;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 1.8rem;
    text-align: center;
    font-size: 1.6rem;
    .bar_item{
      font-weight: 600;
      margin-top: 1rem;
      font-size: 2rem;
    }
  }
  .detail{
    .d_item{
      width: 94vw;
      margin-left: 3vw;
      .month{
        width: 8rem;
        background-color: rgb(210, 210, 210);
        padding: 4px;
        color: white;
        border-radius: 4px;
        font-weight: 400;
        margin: 1rem;
        margin-left: calc(50% - 4rem);
        margin-top: 1.2rem;
        font-size: 1.2rem;
        text-align: center;
        
      }

    }
  }
      .card{
        background-color: #fff;
        padding: 1rem 2rem;
        border-radius: 4px;
        color: rgb(160, 160, 160);
        margin: 1rem 0;
        .top{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 1rem;
          border-bottom: 1px solid rgba(200, 200, 200, 0.4);
          font-size: 1.3rem;
          // width: 90vw;
          font-weight: 400;
          .top_left{
            display: flex;
            align-items: center;    
            color: black;
            font-weight: normal;   
            font-size: 1.5rem;     
            font-weight: normal;

          }
          img{
            vertical-align: top;
            margin-right: 4px;
            width: 2.4rem;
            height: 2.4rem;
          }
        }
        .content{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 2.2rem 0 1.2rem 0;
          .amount{
            color:  #F63A25;
            font-size: 1.8rem;
            font-weight: 600;
          }
        }
      }
  .tips{
    font-size: 1.6rem;
    color: rgba(10, 10, 10, 0.7);
    width: 100vw;
    text-align: center;
    margin-top: 4rem ;
    img{
      opacity: .6;
      width: 2rem;
      height: 2rem;
      vertical-align: middle;
    }
  }
</style>